<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <v-card-title>
            <h3>Informasi Peminjaman</h3>
          </v-card-title>
          <v-snackbar
            v-model="show"
            multi-line="true"
            top="true"
            color="green"
          >
            {{ notifMsg }}
            <v-btn
              color="pink"
              flat
              @click="show = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-snackbar
            v-model="show2"
            multi-line="true"
            top="true"
            color="red"
          >
            {{ notifMsg }}
            <v-btn
              color="pink"
              flat
              @click="show2 = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 lg6>
                <p>Nama PIC : <strong>{{form[0].namaPIC}}</strong></p>
                <p>Jenis Penggunaan :<strong>{{form[0].jenisPenggunaanRuangan}}</strong></p>
                <p>Status :<strong>{{form[0].statusPenggunaanRuangan}}</strong></p>
                <p>File :<strong>{{fileName}}</strong></p>
                <v-btn :disabled="fileName == '' ? true : false" raised color="orange" @click="onDownload">
                  <v-icon dark left>cloud_download</v-icon> Download File
                </v-btn>
              </v-flex>
              <v-flex xs12 lg6>
                <p>Tanggal Mulai:<strong>{{tanggalParse(form[0].mulai)}}</strong></p>
                <p>Tanggal Selesai:<strong>{{tanggalParse(form[0].selesai)}}</strong></p>
                <p>Deskripsi :<strong>{{form[0].deskripsi}}</strong></p>
                <p v-if="form[0].statusPenggunaanRuangan == 'Diajukan'">Tanggal Entry :<strong>{{form[0].timestampDiajukan}}</strong></p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-card-text>
            <v-data-table :headers="headers" :items="items" item-key="id" class="elevation-1">
              <template slot="items" slot-scope="props">
                <td>{{lokasi}}</td>
                <td>{{ props.item.gedung }}</td>
                <td>{{ props.item.kodeRuangan }}</td>
                <td>{{ props.item.namaRuangan }}</td>
                <td>{{ props.item.kapasitas }}</td>
                <td>{{ waktuParse(props.item.mulai) }}</td>
                <td>{{ waktuParse(props.item.selesai) }}</td>
                <td v-if="see2(props.item.jenisPenggunaanRuangan === 'Kuliah Rutin')
                        && props.item.statusPenggunaanRuangan !== 'Ditolak' &&
                        props.item.statusPenggunaanRuangan !== 'Dibatalkan'">
                  <v-tooltip bottom>
                    <v-btn slot="activator"
                           depressed
                           icon
                           fab
                           dark
                           color="primary"
                           small
                           @click="onEdit(props.item.id)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span>Ubah</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-card-title>
            <h3>Komentar</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form class="px-3">
              <v-textarea
                placeholder="Silahkan isi komentar"
                v-model="comment.komentar">
              </v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="btn-komentar"
              color="success"
              dark
              style="width:120px;"
              @click="onComment"
            >
              Kirim Komentar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg12 v-if="komentar.length != 0">
        <v-card>
          <v-card-title>
            <h3>Daftar Komentar</h3>
          </v-card-title>
          <v-card-text>
            <div class="kotak" v-for="(item) in komentar" :key="item">
              <span>{{item.username}}</span>:<br><hr>
              <p>{{item.komentar}}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-btn
      v-if="seen"
      class="btn-simpan"
      color="success"
      dark
      style="width:120px;"
      @click="activate = true"
    >
      Setujui
    </v-btn>
    <v-btn
      v-if="seen"
      class="btn-simpan"
      color="red"
      dark
      style="width:120px;"
      @click="activate2 = true"
    >
      Tolak
    </v-btn>
    <v-btn
      v-if="seen2"
      class="btn-simpan"
      color="yellow darken-1"
      dark
      style="width:200px;"
      @click="activate3 = true"
    >
      Batalkan Peminjaman
    </v-btn>
    <v-btn
      class="btn-kembali"
      color="red"
      dark
      style="width:120px;"
      @click="onKembali"
    >
      Kembali
    </v-btn>

    <v-dialog
      v-model="activate"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Setujui Peminjaman ini?</v-card-title>

        <v-card-text>
          Memilih setuju akan mengubah status peminjaman menjadi di setujui.
        </v-card-text>

        <v-card-actions class="justify-center">
          <div class="flex-grow-1"></div>

          <v-btn
            color="red"
            text
            @click="activate = false"
          >
            Kembali
          </v-btn>

          <v-btn
            color="primary"
            text
            @click="onSetujui()"
          >
            Setuju
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="activate2"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Tolak Peminjaman ini?</v-card-title>

        <v-card-text>
          Memilih setuju akan mengubah status peminjaman menjadi ditolak.
        </v-card-text>

        <v-card-actions class="justify-center">
          <div class="flex-grow-1"></div>

          <v-btn
            color="red"
            text
            @click="activate2 = false"
          >
            Kembali
          </v-btn>

          <v-btn
            color="primary"
            text
            @click="onDitolak()"
          >
            Setuju
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="activate3"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Batalkan Peminjaman ini?</v-card-title>

        <v-card-text>
          Memilih setuju akan mengubah status peminjaman menjadi dibatalkan.
        </v-card-text>

        <v-card-actions class="justify-center">
          <div class="flex-grow-1"></div>

          <v-btn
            color="red"
            text
            @click="activate3 = false"
          >
            Kembali
          </v-btn>

          <v-btn
            color="primary"
            text
            @click="onBatal()"
          >
            Setuju
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {base, urlBase, fileUrl} from "../../setup-axios"
  import {createJWT} from "../../store/module/helper";
  import { mapGetters,  mapActions} from 'vuex'

export default {
  name: "View",
  data() {
    return {
      headers: [
        {
          text: "Lokasi",
          value: ""
        },
        {
          text: "Gedung",
          value: "gedung"
        },
        ,
        {
          text: "Kode Ruangan",
          value: ""
        },
        {
          text: "Nama Ruangan",
          value: "namaRuangan"
        },
        {
          text: "Kapasitas",
          value: "kapasitas"
        },
        {
          text: "Waktu Mulai",
          value: "mulai"
        },
        {
          text: "Waktu Selesai",
          value: "selesai"
        }
      ],

      items: [],
      komentar: [],
      form: {},
      lokasi: "",
      show: false,
      bodyApproval : {
        idStatusPenggunaanRuangan : null,
        usernamePemberiKeputusan : ""
      },
      activate: false,
      activate2: false,
      activate3: false,
      comment: {
        timestamp : null,
        komentar : "",
        username : localStorage.getItem("user"),
        idPenggunaanRuangan : this.$route.params.id
      },
      fileName: ""
    }
  },
  created(){
    base.get("penggunaanRuangan/" + this.$route.params.id,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
    ).then((resp) => {
      this.form = resp.data.result
      this.items = resp.data.result
      this.fileName = this.formattingFileName()
    })

    base.get("komentar/idPenggunaanRuangan/" + this.$route.params.id,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
    ).then((resp) => {
      this.komentar = resp.data.result
    })

    base.get("ruangan/" + this.$route.params.idRuangan,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
    ).then((resp) => {
      this.lokasi = resp.data.resultById.idGedung.idLokasi.nama
    })
  },
  computed: {
    ...mapGetters(["snackbar"]),
    seen(){
      if(this.form[0].idStatusPenggunaanRuangan == 1 && localStorage.getItem("role") == "admin"){
        return true
      }

      if(this.form[0].idStatusPenggunaanRuangan == 1 && localStorage.getItem("role") == "RT"){
        return true
      }

      if(this.form[0].idStatusPenggunaanRuangan == 1 && localStorage.getItem("role") == "ruang"){
        return true
      }

      else {
        return false
      }
    },

    seen2(){
      if(this.form[0].idStatusPenggunaanRuangan != 2
        && this.form[0].idStatusPenggunaanRuangan != 4 && localStorage.getItem("role") == "admin"){
        return true
      }

      if(this.form[0].idStatusPenggunaanRuangan != 2
        && this.form[0].idStatusPenggunaanRuangan != 4 && localStorage.getItem("role") == "RT"){
        return true
      }

      if(this.form[0].idStatusPenggunaanRuangan != 2
        && this.form[0].idStatusPenggunaanRuangan != 4 && localStorage.getItem("role") == "ruang"){
        return true
      }

      if(this.form[0].idStatusPenggunaanRuangan != 2
        && this.form[0].idStatusPenggunaanRuangan != 4
        && this.form[0].idStatusPenggunaanRuangan != 3
        && localStorage.getItem("role") == "mhs"){
        return true
      }

      else {
        return false
      }
    }


  },
  methods: {
    ...mapActions(["fetchSnackbar", "fetchMsgSnackbar", "fetchPathSnackbar"]),
    formattingFileName(){
      var arrPath = this.form[0].urlFile.split("/");
      var arrName = arrPath[2].split("-");
      var fileNameFormatted = "";
      for (var i = 2; i < arrName.length; i++) {
        fileNameFormatted += arrName[i];
          if(i + 1 < arrName.length){
            fileNameFormatted += "-";
          }
      }
      return fileNameFormatted;
    },
    onDownload(){
      console.log("downloading file.. " + fileUrl)
      base.post('penggunaanRuangan/file/download/' + this.$route.params.id, 
             {
               headers: {
                 'Authorization' : createJWT()
               }
             })
          .then((resp) => {
            let ticket = resp.data.ticket
            console.log("get ticket:  " + ticket)
            window.location = fileUrl +'penggunaanRuangan/file/download/' + this.$route.params.id + '?ticket=' + ticket
          })
    },
    onKembali(){
      this.$router.push("/peminjaman/peminjaman")
    },
    onEdit(id){
      this.$router.push("/peminjaman/edit/" + id);
    },
    onBatal() {
      this.bodyApproval.idStatusPenggunaanRuangan = 4
      this.bodyApproval.usernamePemberiKeputusan = localStorage.getItem("user")

      var url = "penggunaanRuangan/approval/" + this.$route.params.id
      let thisVM = this


      base.post( url, this.bodyApproval,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
      ).then((resp) => {
        console.log('Success');
        console.log(resp.data);

        if(resp.data.status == 500){
          thisVM.show2 = true
          thisVM.notifMsg = resp.data.message
        }

        else {
          thisVM.fetchSnackbar(true, 'Berhasil mengubah status menjadi dibatalkan', 'peminjaman')
          thisVM.fetchMsgSnackbar("Berhasil Mengubah status menjadi dibatalkan")
          thisVM.fetchPathSnackbar("peminjaman")
          thisVM.$router.push('/peminjaman/peminjaman')
        }
      }).catch(function(error) {
        console.log('ERROR : ', error)
        console.log('isi dari error', error.response)
        thisVM.show = true
        thisVM.notifMsg = 'Status gagal berubah'
      })
    },

    onDitolak(){
      this.bodyApproval.idStatusPenggunaanRuangan = 2
      this.bodyApproval.usernamePemberiKeputusan = localStorage.getItem("user")

      var url = "penggunaanRuangan/approval/" + this.$route.params.id
      let thisVM = this


      base.post( url, this.bodyApproval,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
      ).then((resp) => {
        console.log('Success');
        console.log(resp.data);
        if(resp.data.status == 500){
          thisVM.show2 = true
          thisVM.notifMsg = resp.data.message
        }

        else {
          thisVM.fetchSnackbar(true, 'Berhasil mengubah status menjadi ditolak', 'peminjaman')
          thisVM.fetchMsgSnackbar("Berhasil Mengubah status menjadi ditolak")
          thisVM.fetchPathSnackbar("peminjaman")
          thisVM.$router.push('/peminjaman/peminjaman')
        }
      }).catch(function(error) {
        console.log('ERROR : ', error)
        console.log('isi dari error', error.response)
        thisVM.show2 = true
        thisVM.notifMsg = 'Status gagal berubah'
      })
    },

    onSetujui(){
      this.bodyApproval.idStatusPenggunaanRuangan = 3
      this.bodyApproval.usernamePemberiKeputusan = localStorage.getItem("user")
      console.log(this.bodyApproval)

      var url = "penggunaanRuangan/approval/" + this.$route.params.id
      let thisVM = this

      base.post( url, this.bodyApproval,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
      ).then((resp) => {
        console.log('Success');
        console.log(resp.data);
        if(resp.data.status == 500){
          thisVM.show2 = true
          thisVM.notifMsg = "Ruangan ini jadwalnya bentrok dengan ruangan lain"
        }

        else {
          thisVM.fetchSnackbar(true, 'Berhasil mengubah status menjadi disetujui', 'peminjaman')
          thisVM.fetchMsgSnackbar("Berhasil Mengubah status menjadi disetujui")
          thisVM.fetchPathSnackbar("peminjaman")
          thisVM.$router.push('/peminjaman/peminjaman')
        }
      }).catch(function(error) {
        console.log('ERROR : ', error)
        console.log('isi dari error', error.response)
        thisVM.show = true
        thisVM.notifMsg = 'Status gagal berubah'
      })
    },

    onComment(){
      var fullDate = this.formatDate(new Date().toISOString().slice(0,10))
      var hours = new Date().getHours()
      var minute = new Date().getMinutes()
      var sec = new Date().getSeconds()
      let thisVM = this

      this.comment.timestamp = fullDate + " " + hours + ":" + minute + ":" + sec

      base.post( "komentar", this.comment,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
      ).then((resp) => {
        console.log('Success');
        console.log(resp.data);

        thisVM.show = true
        thisVM.notifMsg = 'Berhasil Mengirim Komentar'
        location.reload(true);
      }).catch(function(error) {
        console.log('ERROR : ', error)
        console.log('isi dari error', error.response)
        thisVM.show2 = true
        thisVM.notifMsg = 'Terjadi Kesalahan saat mengirim komentar'
      })
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split("-")
      return `${day}-${month}-${year}`
    },

    tanggalParse(value){
      return value.substring(0,10)
    },

    waktuParse(value){
      return value.substring(10,value.length);
    },

    see2(item){
      if(item || localStorage.getItem("role") == "admin" || localStorage.getItem("role") == "RT"
        || localStorage.getItem("role") == "ruang" ){

        return true
      }

      else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  .kotak {
    border: 1px solid grey;
    padding: 5px;
    margin:5px 0;
    overflow: hidden;
  }
</style>